<template>
  <div class="sign-up">
    <h1 class="mb-4">SODA Registrierung</h1>
    <v-form v-model="valid" ref="form" lazy-validation>
      <v-text-field
        outlined
        v-if="!show_user_exists_message"
        v-model="username"
        :rules="emailRules"
        label="Email Adresse"
        placeholder="alex@beispiel.de"
        required
        v-on:input="prop_email()"
      />
      <v-alert outlined dismissible v-model="show_user_exists_message" type="error" transition="scale-transition">
        Ein Nutzer mit der Email {{ username }} existiert bereits.
      </v-alert>
      <v-text-field
        outlined
        v-model="password"
        :append-icon="passwordVisible ? 'visibility' : 'visibility_off'"
        :rules="[
          passwordRules.required,
          passwordRules.mincnt,
          passwordRules.mincap,
          passwordRules.minnum,
          passwordRules.minspc,
        ]"
        :type="passwordVisible ? 'text' : 'password'"
        name="password"
        label="Passwort"
        @click:append="passwordVisible = !passwordVisible"
        required
      />
      <v-checkbox v-model="consent" :rules="consentRules" color="primary">
        <span slot="label" class="caption">
          Ich habe die
          <a href="" v-bind:class="loadTerms" @click="loadTerms">allgemeinen Vertragsbedingungen</a>
          und die
          <a href="" v-bind:class="loadPrivacy" @click="loadPrivacy">Datenschutzerklärung</a>
          zur Kenntnis genommen.
        </span>
      </v-checkbox>
      <v-btn outlined block color="primary" :disabled="!(valid && consent && !working && !had_error)" @click="submit">
        Registrieren
      </v-btn>
    </v-form>
    <div id="docs">
      <v-dialog v-model="show_doc_view" width="800">
        <v-card>
          <v-card-title></v-card-title>
          <v-card-text v-if="doc_text_html">
            <div v-html="doc_text_html"></div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-col class="text-xs-right">
              <v-btn color="green" text v-on:click="dismiss_doc_view()">
                OK
              </v-btn>
            </v-col>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { signUp } from "./auth.js";

const TermsTextURL = require("file-loader!../../assets/TermsText.md");
const PrivacyTextURL = require("file-loader!../../assets/PrivacyText.md");
const md = require("markdown-it")({
  html: true,
  linkify: true,
  typographer: true,
});

export default {
  name: "SignUpView",
  props: {
    email: String,
  },
  mounted() {
    if (this.email) {
      this.username = this.email;
    }
  },
  data() {
    return {
      valid: false,
      working: false,
      had_error: false,
      username: null,
      password: null,
      passwordVisible: false,
      consent: false,
      //lockConsent:
      show_user_exists_message: false,
      show_doc_view: false,
      doc_text_html: null,
    };
  },
  computed: {
    emailRules() {
      return [
        (v) => !!v || "Email ist ein Pflichtfeld",
        (v) => /.+@.+\..+/.test(v) || "Feld muss eine Gültige Email enthalten",
      ];
    },
    passwordRules() {
      return {
        required: (value) => !!value || "Passwort ist ein Pflichtfeld",
        mincnt: (v) => (v && v.length >= 8) || "Mindestens 8 Zeichen",
        mincap: (v) => /[A-Z]/.test(v) || "Mindestens 1 Großbuchstabe",
        minnum: (v) => /[0-9]/.test(v) || "Mindestens 1 Ziffer",
        minspc: (v) =>
          /[\^$*.\[\]{}()?"!@#%&/\\,><':;|_~`]/.test(v) ||
          "Mindestens 1 Sonderzeichen (^ $ * . [ ] { } ( ) ? \" ! @ # % & / \ , > < ' : ; | _ ~ `)",
      };
    },
    consentRules() {
      return [(v) => !!v || "Bitte bestätigen"];
    },
  },
  methods: {
    loadTerms(e) {
      e.stopPropagation();
      e.preventDefault();
      this.fetchText(TermsTextURL);
      this.show_doc_view = true;
    },
    loadPrivacy(e) {
      e.stopPropagation();
      e.preventDefault();
      this.fetchText(PrivacyTextURL);
      this.show_doc_view = true;
    },
    prop_email() {
      this.had_error = false;
      this.$root.$emit("email", this.username);
    },
    async submit() {
      if (this.$refs.form.validate()) {
        console.log("valid");
        this.working = true;
        var result = await signUp(this.username, this.password);
        console.log(result);
        this.working = false;
        if (result.code && result.code === "UsernameExistsException") {
          this.show_user_exists_message = true;
          this.had_error = true;
        }
      }
    },
    fetchText(textURL) {
      var oReq = new XMLHttpRequest();
      oReq.addEventListener("load", (data) => {
        this.doc_text_html = md.render(data.target.responseText);
      });
      oReq.open("GET", textURL);
      oReq.send();
    },
    dismiss_doc_view() {
      this.show_doc_view = false;
      this.doc_text_html = null;
    },
  },
};
</script>

<style>
table {
  border-collapse: collapse;
}

table,
tr,
th {
  border: 1px solid black;
}
</style>
